import script from "./BackgroundAudioPlayer.vue?vue&type=script&setup=true&lang=ts"
export * from "./BackgroundAudioPlayer.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__